import { gql } from "@apollo/client";

export const GET_CONDICIONES_GENERALES_RESUMEN = gql`
query CondicionGeneralRIByID (
    $idDatosGenerales: Int!
) {
    condicionGeneralRIByID (
        idDatosGenerales: $idDatosGenerales
    ){
        idDatosGeneralesRI
        idCondicionGeneralRI
        buenaTolerancia
        continuarOtroTratamiento
        descOtroTratamiento
        inicioDeServicio
        justificacionNoInicio
        dispositivoParaVideoConf
        idComboRIValorFasePacienteNavigation{
            valor
        }
        domicilioAccesible
        aguaPotable
        redElectrica
        comprendeAceptaServicio
        higiene
        internacionDomiciliaria
        cuidador
        almacenamiento
        prestacion
        empresa
        observaciones
        higieneInstitucion
        almacenamientoInstitucion
        personalInstitucion
        evaluacionFamiliaPsicosicial
        conclusion
        consentimientoInformado
        consentimientoOutput{
            contentType
            extension
            titulo
            archivo
        }
        fechaFirmaConsentimiento
    }
}`;